export default function (other) {
  other = other || {}
  return {
    id: other.id || null,
    orgId: other.orgId || null,
    name: other.name || null,
    accountId: other.accountId || null,
    usageType: other.usageType || null,
    status: other.status || null,
    notes: other.notes || null,
    campaignType: other.campaignType || null,
    creationTime: other.creationTime || null,
  }
}
